import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c766e8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table table-bordered mb-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "純資産の部")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "科目"),
    /*#__PURE__*/_createElementVNode("th", null, "金額")
  ])
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "純資産合計", -1))
const _hoisted_12 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_kin = _resolveComponent("input-kin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_ctx.corporationType!==_ctx.corporationTypeType.Type1 || _ctx.outputFundType===_ctx.outputFundTypeType.Shushikin)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _createElementVNode("td", null, _toDisplayString(_ctx.shushikin.kmkName), 1),
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_input_kin, {
                  modelValue: _ctx.localShushikin,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localShushikin) = $event)),
                  "allow-blank": true
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.corporationType!==_ctx.corporationTypeType.Type1 || _ctx.outputFundType===_ctx.outputFundTypeType.Kikin)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
              _createElementVNode("td", null, _toDisplayString(_ctx.kikin.kmkName), 1),
              _createElementVNode("td", _hoisted_7, [
                _createVNode(_component_input_kin, {
                  modelValue: _ctx.localKikin,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localKikin) = $event)),
                  "allow-blank": true
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tsumitateKinItems, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.kmkType
          }, [
            _createElementVNode("td", null, _toDisplayString(item.kmkName), 1),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_input_kin, {
                modelValue: item.kin,
                "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                "allow-blank": true,
                disabled: _ctx.isDisabledByCorporationType(item)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hyokaSagakuItems, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.kmkType
          }, [
            _createElementVNode("td", null, _toDisplayString(item.kmkName), 1),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_input_kin, {
                modelValue: item.kin,
                "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                "allow-blank": true,
                disabled: _ctx.isDisabledByCorporationType(item)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        (_ctx.junshisanGokei)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("td", _hoisted_12, [
                _createVNode(_component_input_kin, {
                  value: _ctx.formatNumberWithCommas(_ctx.junshisanGokei.kin),
                  disabled: ""
                }, null, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}